export default __webpack_public_path__ + "static/media/pictogramBeaconAccounts64.d153fcef.svg";